module.exports = __webpack_public_path__ + "img/es.53a6fd38.svg";